import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react';
import isEmpty from 'lodash/isEmpty';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import PageTitle from '../../components/PageTitle';
import styles from './AddAdjustment.style';
import Module from '../../components/Module';
import Main from '../../components/Main';
import TextButton from '../../components/TextButton';
import AdjustmentForm from '../../components/AdjustmentForm';
import SavingIndicator from '../../components/SavingIndicator';
import useAPI from '../../hooks/useAPI';
import { fetchAdjustmentDetails } from '../../actions/adjustments';

const AddAdjustment = ({ title, mode }) => {
  const { adjustmentId } = useParams();
  const [isSaving, setisSaving] = useState(false);
  const [isSubmiting, setisSubmiting] = useState(false);
  const history = useHistory();
  const formRef = useRef();
  const { contractAddress } = useLocation();
  const handleCancel = () => {
    history.push('/adjustments');
  };

  const handleFormSumbission = async () => {
    await formRef.current.submitForm();
    if (formRef.current && !isEmpty(formRef.current.errors)) {
      setisSaving(false);
      setisSubmiting(false);
    }
  };

  const handleSave = async () => {
    setisSaving(true);
    await formRef.current.setFieldValue('submitButtonType', 'Save');
    await handleFormSumbission();
  };

  const handleSubmit = async () => {
    setisSubmiting(true);
    await formRef.current.setFieldValue('submitButtonType', 'Submit');
    await handleFormSumbission();
  };

  const handleFailure = () => {
    setisSaving(false);
    setisSubmiting(false);
  };

  const handleSuccess = async newAdjustment => {
    setisSaving(false);
    setisSubmiting(false);
    history.push(`/adjustments/${newAdjustment._id}`);
  };

  let isLoading = false;

  if (adjustmentId)
    ({ isLoading } = useAPI(() => fetchAdjustmentDetails(adjustmentId), [adjustmentId]));

  if (isLoading) {
    return (
      <Spinner
        data-testid="addAdjustmentsSpinner"
        size={SpinnerSize.medium}
        className={styles.loadingSpinner}
      />
    );
  }

  return (
    <>
      <PageTitle>{title}</PageTitle>
      <Main>
        <Module>
          <AdjustmentForm
            onSuccess={handleSuccess}
            onFailure={handleFailure}
            ref={formRef}
            adjustmentId={adjustmentId}
            mode={mode}
            contractAddress={contractAddress}
          />
        </Module>

        <div className={styles.buttonContainer}>
          <TextButton className={styles.cancelButton} onClick={handleCancel}>
            Cancel
          </TextButton>

          {!isSaving ? (
            <DefaultButton
              className={styles.saveDraftButton}
              onClick={handleSave}
              disabled={isSaving}
              data-testid="adjustmentFormSaveDraft"
            >
              {mode === AdjustmentForm.MODE.MINOR ? 'Save' : 'Save Draft'}
            </DefaultButton>
          ) : (
            <SavingIndicator data-testid="saveLoader" className={styles.saveDraftButton} />
          )}

          {mode !== AdjustmentForm.MODE.MINOR &&
            (!isSubmiting ? (
              <PrimaryButton data-testid="adjustmentFormSubmit" onClick={handleSubmit}>
                Submit for Approval
              </PrimaryButton>
            ) : (
              <SavingIndicator data-testid="submitLoader" className={styles.saveDraftButton} />
            ))}
        </div>
      </Main>
    </>
  );
};

AddAdjustment.propTypes = {
  title: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(Object.values(AdjustmentForm.MODE)).isRequired,
};

export default AddAdjustment;
